import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
export default function SingleDatePicker({ control, name, label, errors, readOnly = false, minDate, maxDate }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <DatePicker
            timezone={'Asia/Kuala_Lumpur'}
            id={name}
            label={label}
            format="YYYY-MM-DD"
            renderInput={(params) => <TextField {...field} fullWidth />}
            onChange={(date) => field.onChange(date)}
            value={field.value}
            readOnly={readOnly}
            minDate={minDate}
            maxDate={maxDate}
            slotProps={{
              textField: {
                fullWidth: true,
                error: !!errors.document_date,
                helperText: errors.document_date?.message,
              },
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
}
